import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface searchWeixinAccountCardParams extends ActiomCommonParams {
    token: string | number;
    searchValue: string;
    pageNum: number;
}

export interface WxAccountCardInfo {
    fakeid: string;
    nickname: string;
    alias: string;
    round_head_img: string;
    service_type: number;
    signature: string;
    verify_status: number;
}

export type PublishAction = CommonAction<searchWeixinAccountCardParams, WxAccountCardInfo[]>;

export const searchWeixinAccountCard: PublishAction = async (_task, params) => {
    const { token } = params;
    if (!token) return { code: 414, message: "缺少token", data: [] };
    const fingerprint = "4695500bc93ab4ce8fb2692da6564e04";

    try {
        const http = new Http({
            headers: {
                cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            },
        });

        const accountCardList = await http.api<{
            base_resp: { err_msg: string; ret: number };
            list: WxAccountCardInfo[];
        }>({
            method: "get",
            url: "https://mp.weixin.qq.com/cgi-bin/searchbiz",
            params: {
                token,
                lang: "zh_CN",
                action: "search_biz",
                scene: params.pageNum - 1 || 0,
                begin: "0",
                count: "10",
                query: params.searchValue,
                fingerprint,
                f: "json",
                ajax: 1,
            },
        });

        return success(accountCardList.list, "微信搜索账户数据成功！");
    } catch (_error) {
        return success([], "微信搜索账户数据失败！");
    }
};
